import axios from 'axios';

export default {
  fetchNotifications(params){
    return axios.get(process.env.VUE_APP_NOTIFICATION_API_URL+":"+process.env.VUE_APP_NOTIFICATION_API_PORT+"/API/v1/notifications", { params: { userId: 2 }} )
      .then(results=>{
        return results.data;
      })
  },
}
